import { useEffect, useState } from "react";
import styled from "styled-components";
import { popIn, slideReveal } from "./Autopilot.styled";
import { radius } from "@libertify/ui";

export const TemplatesVisual: React.FC<{
  isActive: boolean;
  isDone: boolean;
}> = ({ isActive, isDone }) => {
  const [visibleCount, setVisibleCount] = useState(isDone ? 3 : 0);
  const [selectedIdx, setSelectedIdx] = useState<number | null>(
    isDone ? 1 : null
  );

  useEffect(() => {
    if (!isActive) return;
    const timers: ReturnType<typeof setTimeout>[] = [];
    [0, 1, 2].forEach((i) => {
      timers.push(setTimeout(() => setVisibleCount((c) => c + 1), i * 350));
    });
    timers.push(setTimeout(() => setSelectedIdx(1), 3 * 350 + 800));
    return () => timers.forEach(clearTimeout);
  }, [isActive]);

  return (
    <TemplatesRow>
      {[0, 1, 2].map((i) => {
        if (i >= visibleCount) return null;
        const isSelected = selectedIdx === i;
        const hasSelection = selectedIdx !== null;
        return (
          <TemplateCard
            key={i}
            $isSelected={isSelected}
            $hasSelection={hasSelection}
          >
            <TemplateBar />
            <TemplateBar $w="70%" />
            <TemplateBar $w="50%" />
          </TemplateCard>
        );
      })}
    </TemplatesRow>
  );
};

const TemplatesRow = styled.div`
  padding: 14px 15px 12px;
  display: flex;
  gap: 10px;
  animation: ${slideReveal} 0.3s ease both;
`;

const TemplateCard = styled.div<{
  $isSelected: boolean;
  $hasSelection: boolean;
}>`
  width: 80px;
  height: 112px;
  border-radius: ${radius.box}px;
  border: 1.5px solid ${(p) => (p.$isSelected ? "#14B8A6" : "#E5E7EB")};
  background: linear-gradient(145deg, #f9fafb, #f3f4f6);
  overflow: hidden;
  padding: 10px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  filter: ${(p) => (p.$isSelected ? "grayscale(0)" : "grayscale(1)")};
  opacity: ${(p) => (!p.$hasSelection || p.$isSelected ? 1 : 0.5)};
  transform: ${(p) => (p.$isSelected ? "scale(1.04)" : "scale(1)")};
  box-shadow: ${(p) =>
    p.$isSelected ? "0 4px 20px rgba(20,184,166,0.25)" : "none"};
  transition:
    filter 0.5s ease,
    opacity 0.5s ease,
    transform 0.5s ease,
    box-shadow 0.5s ease,
    border-color 0.5s ease;
  animation: ${popIn} 0.3s ease both;
`;

const TemplateBar = styled.div<{ $w?: string }>`
  height: 6px;
  border-radius: ${radius.pill}px;
  background: #d1d5db;
  width: ${(p) => p.$w ?? "100%"};
`;
